import { reloadStaleJointValues } from "../../articulation/reloadJointValues";
import { BabylonState } from "../../state";

import { reloadStaleGlobalPositions } from "./reloadGlobalPositions";
import { reloadStaleGrid } from "./reloadGrid";
import { reloadStaleMeshes } from "./reloadMeshes";
import { reloadStalePaths } from "./reloadPaths";
import { reloadStalePositions } from "./reloadPositions";
import { reloadStaleRotations } from "./reloadRotations";
import {
  reloadStaleVectorFieldCaches,
  reloadStaleVectorFieldMeshes,
} from "./reloadVectorFields";
import { reportDataLoading } from "./reportDataLoading";

/**
 * Schedules data loads for any components whose data has gone stale, then
 * reports whether anything is loading.
 *
 * Order matters where components feed each other: local position caches are
 * loaded first, composed into absolute trajectories second, and only then baked
 * into path and vector-field geometry.
 */
export function reloadStaleComponents(state: BabylonState) {
  reloadStaleGrid(state);
  reloadStalePositions(state);
  // Before globals are composed, which now read orientation as well as offset.
  reloadStaleRotations(state);
  reloadStaleGlobalPositions(state);
  reloadStalePaths(state);
  reloadStaleVectorFieldCaches(state);
  reloadStaleVectorFieldMeshes(state);
  reloadStaleMeshes(state);
  // Last, and order-independent: a joint value feeds no other component's cache
  // — it moves nodes inside one model rather than composing through the entity
  // hierarchy — so nothing above depends on it having run.
  reloadStaleJointValues(state);
  // After every fetch above has started, and in the same task, so a load is
  // reported before its fetch yields rather than at the next frame.
  reportDataLoading(state);
}
